import * as React from 'react';
import { Table } from 'antd';
import { VisualMemoryScoresBox } from './VisualMemoryScores.css';
import UserContext from '../../../../../contexts/UserContext';
import { getUserScores, IUserScore } from '../api';
import { displayDate, displayTime } from '../../../../../games/functions';
import ShowTime from '../../../../components/ShowTime/ShowTime';

const tColumns = [
    {
        title: 'Level',
        dataIndex: 'level',
    },
    {
        title: 'Time',
        dataIndex: 'time',
        render: (time: number) => <ShowTime time={displayTime(time)} sufix='s' />
    },
    {
        title: 'Date',
        dataIndex: 'date',
        render: (date: string) => displayDate(date),
    }
]

const VisualMemoryScores = (props: { gameId: number }) => {
    const {gameId} = props;
    const {useState, useContext, useEffect} = React;
    const {user} = useContext(UserContext);
    const [userScores, setUserScores] = useState<IUserScore[]>([]);

    useEffect(() => {
        (async function() {
            const scores = await getUserScores(user.id, gameId);
            setUserScores(scores);
        })();
    }, []);

    return (
        <VisualMemoryScoresBox>
            <Table columns={tColumns} dataSource={userScores} pagination={false} />
        </VisualMemoryScoresBox>
    );
};

export default VisualMemoryScores;